import { useEffect, useRef, useState } from "react";

/**
 * Web Speech API hook. Uses browser's built-in SpeechRecognition (webkit).
 * Returns { supported, listening, transcript, start, stop, reset }.
 */
export default function useSpeechRecognition(lang = "de-DE") {
  const Rec = typeof window !== "undefined"
    ? (window.SpeechRecognition || window.webkitSpeechRecognition)
    : null;
  const supported = !!Rec;
  const recRef = useRef(null);
  const [listening, setListening] = useState(false);
  const [transcript, setTranscript] = useState("");

  useEffect(() => {
    if (!supported) return;
    const r = new Rec();
    r.lang = lang;
    r.interimResults = true;
    r.continuous = true;
    r.onresult = (e) => {
      let text = "";
      for (let i = 0; i < e.results.length; i++) text += e.results[i][0].transcript;
      setTranscript(text);
    };
    r.onend = () => setListening(false);
    r.onerror = () => setListening(false);
    recRef.current = r;
    return () => { try { r.stop(); } catch (_) { void 0; } };
  }, [supported, Rec, lang]);

  const start = () => {
    if (!recRef.current) return;
    setTranscript("");
    try { recRef.current.start(); setListening(true); } catch (_) { void 0; }
  };
  const stop = () => { try { recRef.current?.stop(); } catch (_) { void 0; } setListening(false); };
  const reset = () => setTranscript("");

  return { supported, listening, transcript, start, stop, reset };
}
